module.exports = __webpack_public_path__ + "img/tradeDetailsImg.a345179f.svg";